exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".partners__pictiure[data-v-788744f7]{opacity:.8;-ms-transform:scale(.9);transform:scale(.9);transition:.2s ease-in-out}.partners__pictiure[data-v-788744f7]:hover{opacity:1;-ms-transform:scale(1);transform:scale(1);transition:.2s ease-in-out}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-788744f7","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/uikit/components/AppDefaultLayout/components/sections/partners/Partners.vue
// module id = 55c034024af9394dffaf
// module chunks = 0